function generateBoxShadows(n: number): string {
  const width = typeof window !== 'undefined' ? window.innerWidth : 4000
  const height = typeof window !== 'undefined' ? window.innerHeight : 3000
  const shadows: string[] = []
  for (let i = 0; i < n; i++) {
    const x = Math.floor(Math.random() * width)
    const y = Math.floor(Math.random() * height)
    shadows.push(`${x}px ${y}px #FFF`)
  }
  return shadows.join(', ')
}

const shadowsSmall = generateBoxShadows(1400)
const shadowsMedium = generateBoxShadows(800)
const shadowsBig = generateBoxShadows(400)

export default function Stars() {
  return (
    <>
      <div className="stars-small" style={{ boxShadow: shadowsSmall }} />
      <div className="stars-medium" style={{ boxShadow: shadowsMedium }} />
      <div className="stars-big" style={{ boxShadow: shadowsBig }} />
    </>
  )
}
